import React from 'react';
import Head from '../Header/Head';
import Header from '../Header/Header';
import AuthorProfileHeader from './AuthorProfileHeader';
import MiniAuthorProfileHeader from './MiniAuthorProfileHeader';

const AuthorProfile = props => {
  // eslint-disable-next-line one-var
  let displayName = props.username;
  let { username } = props;
  let coverImage;
  let about;
  let roles;
  let avatar;
  if (props.profile && props.profile.author) {
    coverImage = props.profile.coverImage;
    about = props.profile.about;
    displayName = props.profile.author.displayName;
    roles = props.profile.author.roles;
    username = props.profile.author.username;
    avatar = props.profile.author.avatar;
  }

  return (
    <>
      <Head
        shorttitle={`${displayName}'s Travel Blog`}
        image={coverImage}
        description={`${displayName}'s Travel Blog: ${about}`}
        profile={props.profile}
        includeMapbox
        feedUrl={`@${username}`}
        noIndex={!props.profile.isIndex}
        noFollow={!props.profile.isIndex}
      />
      <Header active="blog" subheader={displayName} author={username} />
      {props.isMini ? (
        <MiniAuthorProfileHeader
          data={{
            name: username,
            displayName,
            isBlacklisted: roles && roles.indexOf('blacklist') !== -1,
            isCurator: roles && roles.indexOf('team') !== -1,
            isVideo: roles && roles.indexOf('video') !== -1,
            coverImage,
            profileImage: avatar,
          }}
        />
      ) : (
        <AuthorProfileHeader
          data={{
            name: username,
            displayName,
            isBlacklisted: roles && roles.indexOf('blacklist') !== -1,
            isCurator: roles && roles.indexOf('team') !== -1,
            isVideo: roles && roles.indexOf('video') !== -1,
            coverImage,
            profileImage: avatar,
          }}
        />
      )}
    </>
  );
};

export default AuthorProfile;
